import { AgencyProperties } from '@/infrastructure/network/Monitaro/schema/models'

export interface IAgencyProps {
  id?: string
  name: string | null
  kana: string | null
  properties: AgencyProperties | null
  createdAt: string | null
  updatedAt: string | null
}

export default class AgencyEntity {
  private _props: IAgencyProps

  constructor(props?: IAgencyProps | null) {
    this._props = EmptyAgencyPropsFactory(props)
  }

  get props(): IAgencyProps {
    return this._props
  }

  get clone(): IAgencyProps {
    return structuredClone(this._props)
  }

  get id(): string | undefined {
    return this._props.id
  }

  get name(): string | null {
    return this._props.name
  }

  get kana(): string | null {
    return this._props.kana
  }

  get properties(): AgencyProperties | null | undefined {
    return this._props.properties
  }

  get createdAt(): string | null {
    return this._props.createdAt
  }

  get updatedAt(): string | null {
    return this._props.updatedAt
  }
}

export const headers = [{ text: 'ID', value: 'id' }]

export const EmptyAgencyPropsFactory = (props?: Partial<IAgencyProps> | null): IAgencyProps => ({
  name: null,
  kana: null,
  properties: null,
  createdAt: null,
  updatedAt: null,
  ...props
})
